<template>
  <b-modal
    id="user_otp_verification"
    name="user_otp_verification"
    ref="user_otp_verification"
    centered
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
    title="OTP Verification"
  >
    <p class="text-muted text-center mb-3">
      Enter the 4-digit OTP sent to your mobile
    </p>

    <!-- OTP INPUT BOXES -->
    <div class="d-flex justify-content-center mb-4">
      <input
        v-for="(digit, index) in otp"
        :key="index"
        ref="otpInputs"
        type="text"
        class="form-control otp-input mx-1"
        maxlength="1"
        inputmode="numeric"
        v-model="otp[index]"
        @input="onInput(index)"
        @keydown.backspace="onBackspace(index)"
        @paste="onPaste"
      />
    </div>

    <!-- ERROR -->
    <div v-if="errorMsg" class="text-danger text-center mb-3">
      {{ errorMsg }}
    </div>

    <!-- NUM PAD -->
    <div class="numpad">
      <button
        v-for="n in 9"
        :key="n"
        class="btn btnNumpadLight"
        @click="addDigit(n)"
      >
        {{ n }}
      </button>

      <button class="btn btn-outline-danger" @click="clearOtp">
        Clear
      </button>

      <button class="btn btn-light" @click="addDigit(0)">
        0
      </button>

      <button class="btn btn-outline-secondary" @click="removeDigit">
        ⌫
      </button>
    </div>

    <!-- VERIFY -->
    <div class="text-center mt-4">
      <b-button
        variant="primary"
        class="px-5"
        :disabled="!isOtpComplete || loading"
        @click="verifyOtp"
      >
        {{ loading ? "Verifying..." : "Verify OTP" }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    openModal: Boolean,
    onClickHandler: {
      type: Function
    },
  },
  data() {
    return {
      otp: ["", "", "", ""],
      loading: false,
      errorMsg: "",
      numbers: [1, 2, 3, 4, 5, 6, 7, 8, 9]
    };
  },

  computed: {
    otpDigits() {
      return this.otp.padEnd(4, "").split("");
    },
    isOtpComplete() {
      return this.otp.every(d => d !== "");
    },

    otpValue() {
      return this.otp.join("");
    }
  },

  watch: {
    openModal(newVal) {
      if (newVal) {
        this.$refs["user_otp_verification"].show();
      } else {
        this.otp = ["", "", "", ""];
        this.$refs["user_otp_verification"].hide();
      }
    }
  },

  methods: {
    openOtpModal() {
      this.resetOtp();
      this.$bvModal.show("otpModal");
      this.$nextTick(() => this.$refs.otpInputs[0].focus());
    },

    addDigit(num) {
      const index = this.otp.findIndex(d => d === "");
      if (index !== -1) {
        this.$set(this.otp, index, String(num));
        this.$nextTick(() => {
          if (index < 3) this.$refs.otpInputs[index + 1].focus();
        });
      }
    },

    onInput(index) {
      if (!/^\d$/.test(this.otp[index])) {
        this.$set(this.otp, index, "");
        return;
      }
      if (index < 3) this.$refs.otpInputs[index + 1].focus();
    },

    onBackspace(index) {
      if (this.otp[index] === "" && index > 0) {
        this.$refs.otpInputs[index - 1].focus();
      }
    },

    removeDigit() {
      for (let i = 3; i >= 0; i--) {
        if (this.otp[i] !== "") {
          this.$set(this.otp, i, "");
          this.$refs.otpInputs[i].focus();
          break;
        }
      }
    },

    clearOtp() {
      this.otp = ["", "", "", ""];
      this.$nextTick(() => this.$refs.otpInputs[0].focus());
    },

    onPaste(e) {
      const pasted = e.clipboardData.getData("text").replace(/\D/g, "");
      if (pasted.length === 4) {
        this.otp = pasted.split("");
        this.$nextTick(() => this.$refs.otpInputs[3].focus());
      }
      e.preventDefault();
    },

    resetOtp() {
      this.otp = ["", "", "", ""];
      this.loading = false;
      this.errorMsg = "";
    },

    async verifyOtp() {
      if (!this.isOtpComplete) return;
      this.$emit("otp-verified", this.otpValue);
    },
  }
};
</script>

<style scoped>
.otp-input {
  width: 54px;
  height: 58px;
  font-size: 22px;
  font-weight: 600;
  text-align: center;
  border-radius: 10px;
}

.otp-input:focus {
  border-color: #0d6efd;
  box-shadow: 0 0 0 0.15rem rgba(13, 110, 253, 0.25);
}

.numpad {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin-inline: 65px;
}

.numpad button {
  height: 52px;
  font-size: 18px;
  font-weight: 500;
  border-radius: 8px;
}

.btnNumpadLight {
      color: #212529;
    /* background-color: #f8f9fa; */
    border-color: #f8f9fa;
    box-shadow: 1px 1px 1px 1px lightgray;
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/PosLoginOTP.vue